import * as React from 'react';

import { BankIcon } from '../../../components/NewbuildingPromos/parts/PromoItem/BankIcon';
import { getPromoIcon } from '../../../components/NewbuildingPromos/parts/PromoItem/PromoIcons/getPromoIcon';
import { EPromoType, IPromoInfo } from '../../../types/newbuildingPromos';

interface IPromoIconProps {
  promo: IPromoInfo;
}

export const PromoIcon: React.FC<IPromoIconProps> = ({ promo }) => {
  const { promoType } = promo;

  return promoType === EPromoType.Bank ? <BankIcon bank={promo.bank} /> : getPromoIcon(promoType);
};
